import React from "react";
import { Link } from "react-router-dom";
import rightArrow from "../../../../../assets/svgs/ic_right_arrow_primary.svg";

export default function FooterLinks() {
  return (
    <div className="flex flex-col items-center gap-[20px] max-w-[390px]">
      <p className="text-secondary text-md leading-[24px] text-center">
        By signing up, you agree to our{" "}
        <Link
          to="https://www.teambox.dev/policy?section=terms"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary font-medium"
        >
          Terms of Service
        </Link>{" "}
        and{" "}
        <Link
          to="https://www.teambox.dev/policy?section=privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary font-medium"
        >
          Data Processing Agreement
        </Link>
        .
      </p>
      <span>-</span>
      <p className="text-secondary text-md leading-[24px] flex flex-row items-center gap-[6px]">
        Already have an account?{" "}
        <Link
          to="/auth/login"
          className="text-primary text-md leading-[24px] font-medium flex flex-row items-center"
        >
          Log in <img sizes="16px" src={rightArrow} alt="Arrow" />
        </Link>
      </p>
    </div>
  );
}
